import React from 'react';
import { Download } from 'react-feather';
import { List } from '../../core/List';
import { Card } from '../../core/Card';

export const MisalignedSkuFeatureOffsets = () => {

    return (
        <Card title='Health' subtitle='Check skus integrity health here'>
            <div className="skus-health">
                <List
                    controller='api/esko/health/sku/feature'
                    action=''
                    headers={[
                        { column: 'globalOrderId', title: 'Order Number', sortable: true },
                        { column: 'skuId', title: 'Sku Number', sortable: true },
                        { column: 'featureName', title: 'Feature', sortable: false },
                        { column: 'featureOptionName', title: 'Feature Option', sortable: false },
                        { column: 'featureOffset', title: 'Feature Offset', sortable: false },
                        { column: 'error', title: 'Error', sortable: false }
                    ]}
                    onRenderRow={(column, item, header) => {
                        switch (column) {
                            case 'download':
                                return (<span title="Download"><Download onClick={() => window.location.href = "/api/esko/file/" + item.id}></Download></span>)
                            default:
                                return (<span>{item[column]} &nbsp; </span>);
                        }
                    }}
                />
            </div>
        </Card>
    )
}